import { render, staticRenderFns } from "./lanternSlide.vue?vue&type=template&id=67b695cc&scoped=true"
import script from "./lanternSlide.vue?vue&type=script&lang=js"
export * from "./lanternSlide.vue?vue&type=script&lang=js"
import style0 from "./lanternSlide.vue?vue&type=style&index=0&id=67b695cc&prod&lang=scss&scoped=true"
import style1 from "./lanternSlide.vue?vue&type=style&index=1&id=67b695cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b695cc",
  null
  
)

export default component.exports